const PACKAGES = "PACKAGES";
const PACKAGES_SUCCESS = "PACKAGES_SUCCESS";
const PACKAGES_FAILURE = "PACKAGES_FAILURE";
const CLEAR_PACKAGES = "CLEAR_PACKAGES";

const PackagesSymbols = {
  PACKAGES_SUCCESS,
  PACKAGES_FAILURE,
  PACKAGES,
  CLEAR_PACKAGES,
};

export default PackagesSymbols;
